import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Text } from "@/components/typography";
import { Stack } from "@/components/layout";
import styles from "./ui.module.css";

export interface SectionHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function SectionHeader({
  title,
  description,
  actions,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn(styles.sectionHeader, className)}>
      <Stack gap={4}>
        <Text role="h2" as="h2">
          {title}
        </Text>
        {description ? (
          <Text role="body" color="secondary" as="p">
            {description}
          </Text>
        ) : null}
      </Stack>
      {actions ? <div>{actions}</div> : null}
    </div>
  );
}
